__turbopack_context__.v({
  "containerLogos": "H7ITWq_containerLogos",
  "editoras": "H7ITWq_editoras",
  "itemLogo": "H7ITWq_itemLogo",
  "title": "H7ITWq_title",
});
